
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specialSubscription",
      function () {
        return require("private-next-pages/specialSubscription.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specialSubscription"])
      });
    }
  